import React from 'react';
import { Link } from 'react-router-dom';

const ArticelMainImage = ({articleInfo}) => (
    <>
    <img src={articleInfo.main_image} alt= "main_image" className="article_main_image_element" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1080px, 100vw"></img>
    </>
);

export default ArticelMainImage;